module.exports = __webpack_public_path__ + "img/group23-ko.bf3b8cde.png";